/** Tag hues that stay clear of the event status chips (gray, red, violet, fuchsia, emerald); the web maps each name to its classes. */
export const CAL_TAG_COLORS = ['orange', 'amber', 'lime', 'sky', 'indigo'];
//# sourceMappingURL=cal-tag-colors.js.map